<template>
    <v-container fluid fill-height :class="$vuetify.breakpoint.xsOnly ? 'container-menor' : ''">
        <v-layout flex align-center justify-center>
            <v-flex xs12 sm6 md4>
                <v-toolbar color="primary">
                    <v-toolbar-title class="white--text">Apisul Seguros</v-toolbar-title>
                </v-toolbar>
                <v-card v-if="!tokenVerificado">
                    <v-card-text>
                        <v-container fill-height>
                            <v-layout column justify-center align-center>
                                <v-progress-circular indeterminate :size="70" :width="6" color="grey">
                                    <v-layout flex align-center justify-center>
                                        <v-flex xs4>
                                            <v-icon medium color="grey">locker</v-icon>
                                        </v-flex>
                                    </v-layout>
                                </v-progress-circular>
                                <h4 class="themeGrey--text">Verificando autenticidade</h4>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card v-else>
                    <v-card-text>
                        <v-form ref="esqueciSenhaForm" v-model="esqueciSenhaFormValid">
                            <v-container grid-list-lg>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field label="Senha"
                                            id="campoSenha"
                                            v-model="esqueciSenha.senha"
                                            :rules="regras.senha"
                                            :type="!verSenha ? 'password' : 'text'"
                                            :append-icon="!verSenha ? 'visibility' : 'visibility_off'"
                                            :append-icon-cb="() => (verSenha = !verSenha)"
                                            required>                  
                                        </v-text-field> 
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field label="Repita a senha"
                                            id="campoRepitaSenha"
                                            v-model="esqueciSenha.repitaSenha"
                                            :rules="regras.repitaSenha"
                                            :type="!verRepitaSenha ? 'password' : 'text'"
                                            :append-icon="!verRepitaSenha ? 'visibility' : 'visibility_off'"
                                            :append-icon-cb="() => (verRepitaSenha = !verRepitaSenha)"
                                            required>                  
                                        </v-text-field> 
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="alterarSenha" id="cadastrarSenhaBtn" :disabled="!esqueciSenhaFormValid || snackbar.sucesso" color="primary">Cadastrar</v-btn>
                    </v-card-actions>
                </v-card>
                <v-dialog v-model="modalErro" max-width="500px">
                    <v-card>
                        <v-card-text>
                            <v-container fill-height>
                                <v-layout column justify-center align-center>
                                    <v-flex xs12>
                                        <v-icon class="display-3" color="error">error</v-icon>
                                    </v-flex>
                                    <h4 class="error--text">{{ modalErroMensagem }}</h4>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-snackbar
                    :timeout="6000"
                    :color="snackbar.sucesso ? 'success' : 'error'"
                    multi-line
                    v-model="snackbar.visivel">
                    {{ snackbar.mensagem }}
                    <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
                </v-snackbar>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'CadastrarSenha',
    data: () => {
        return {
            esqueciSenhaFormValid: false,
            tokenVerificado: false,
            modalErro: false,
            modalErroMensagem: '',
            snackbar: {
                sucesso: false,
                visivel: false,
                mensagem: ''
            },
            verSenha: false,
            verRepitaSenha: false,
            esqueciSenha: {
                senha: '',
                repitaSenha: ''
            },
            regras: {
                senha: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                repitaSenha: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ]
            },
        }
    },
    watch: {
        modalErro: function (newValue, oldValue) {
            if (oldValue && !newValue) {
                this.$router.push('/');
            }
        }
    },
    mounted: function () {
        this.verificaToken();
    },
    methods: {
        verificaToken: function () {
            const self = this;
            setTimeout(function () { //Para causar sensação de segurança
                axios.get(`${process.env.URL_USUARIOMS}/v1/no-auth/verificaToken?token=${self.$route.params.token}`)
                .then((response) => {
                    if (response.data) {
                        self.tokenVerificado = true;
                    } else {
                        self.modalErro = true;
                        self.modalErroMensagem = 'Não é permitido realizar esta ação';
                    }
                })
                .catch((err) => {
                    self.modalErro = true;
                    self.modalErroMensagem = 'Não é permitido realizar esta ação';
                });
            }, 3000);
        },
        verificaSenhas: function () {
            const self = this;
            if (self.esqueciSenha.senha != self.esqueciSenha.repitaSenha) {
                self.snackbar.sucesso = false;
                self.snackbar.visivel = true;
                self.snackbar.mensagem = 'As senhas não combinam';
                return false;
            }
            return true;
        },
        alterarSenha: function () {
            const self = this;
            if (self.verificaSenhas()) {
                axios.post(`${process.env.URL_USUARIOMS}/v1/no-auth/trocaSenha`, {
                    token: self.$route.params.token,
                    senha: self.esqueciSenha.senha
                })
                .then((response) => {
                    self.snackbar.sucesso = true;
                    self.snackbar.visivel = true;
                    self.snackbar.mensagem = 'Senha cadastrada com sucesso';
                    setTimeout(function () {
                        self.$router.push('/Login'); 
                    }, 6000);
                })
                .catch((err) => {
                    self.snackbar.visivel = true;
                    self.snackbar.sucesso = false;
                    self.snackbar.mensagem = err.response.data.message;

                })
            }
        }
    }
}
</script>

<style scoped>
.container-menor {
    padding: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/login/CadastrarSenha.vue